import { render } from "./CampaignsDetailPerformancePerProduct.vue?vue&type=template&id=63171698&scoped=true"
import script from "./CampaignsDetailPerformancePerProduct.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailPerformancePerProduct.vue?vue&type=script&lang=js"

import "./CampaignsDetailPerformancePerProduct.vue?vue&type=style&index=0&id=63171698&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63171698"]])

export default __exports__